import {connect} from '../../app/connect';
import TemplatesProjectGridHeader from './TemplatesProjectGridHeader';
import {isTemplatesFilterChanged} from '../../app/selectors';
import {changeLocationAction, openManageTemplateCategoriesModal} from '../../app/actions';

const mapStateToProps = state => ({
  isFiltered: isTemplatesFilterChanged(state)
});

const mapDispatchToProps = {
  changeLocationAction,
  openManageTemplateCategoriesModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesProjectGridHeader);
